import FilterListIcon from '@mui/icons-material/FilterList';
import { Autocomplete, Box, IconButton, TextField } from '@mui/material';
import { Dispatch, FunctionComponent, SetStateAction } from 'react';
import { useAppTranslate } from '../../../core/hooks';
import { Card } from '../../../ui/components';
import { L3ServiceLocationViewModel } from '../../model';
import { TopologyFilterValues } from '../TopologyFilters/TopologyFilters';
import { TopologyL3ServiceStatusPoint } from '../TopologyL3ServiceStatusPoint/TopologyL3ServiceStatusPoint';

interface Props {
  locations: L3ServiceLocationViewModel[] | null;
  setFiltersVisible: Dispatch<SetStateAction<boolean>>;
  updateFilters: Dispatch<SetStateAction<TopologyFilterValues>>;
}

export const TopologyToolbar: FunctionComponent<Props> = ({
  locations,
  updateFilters,
  setFiltersVisible,
}) => {
  const translate = useAppTranslate();

  return <Card>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
      <Autocomplete
        options={locations || []}
        sx={{ width: '100%' }}
        getOptionLabel={location => `${location.serviceName} | ${location.orderNumber} | ${location.formattedAddress}`}
        onChange={(event, selectedLocation) => {
          updateFilters(prev => ({ ...prev, selectedLocation }));
        }}
        renderInput={(params) => <TextField {...params} placeholder={translate('filters.titles.search')} />}
        renderOption={(props, option, state, ownerState) => {
          // eslint-disable-next-line react/prop-types
          return <li {...props} style={{ ...(props.style || {}) }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                border: '1px rgb(217, 217, 217) solid',
                p: 1,
                borderRadius: 2,
                width: '100%',
                '&:hover': {
                  backgroundColor: '#3253e40d',
                }
              }}
            >
              <TopologyL3ServiceStatusPoint status={option.serviceStatus} />
              <span>{`${option.serviceName} | ${option.orderNumber} | ${option.formattedAddress}`}</span>
            </Box>
          </li>
        }
        }
      />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <IconButton
          onClick={() => {
            setFiltersVisible(prev => !prev);
          }}
          data-testid={'filters-button'}
        >
          <FilterListIcon />
        </IconButton>
      </Box>
    </Box>
  </Card>;
};
